import Link from 'next/link'
import { LuArrowLeftToLine } from 'react-icons/lu'

import { useLayoutContext } from '@/lib/core/components/Layout'
import {
  FloatingWrapper,
  Footer,
  ToggleButton,
  ToggleIcon,
} from '@/lib/core/components/Layout/SidebarFooter/SidebarFooter.styles'
import { useSidebarStore } from '@/lib/stores/sidebarStore'

export const SidebarFooter = () => {
  const { isMenuExpanded } = useLayoutContext()
  const toggleSidebar = useSidebarStore((state) => state.toggleSidebar)

  return (
    <FloatingWrapper>
      <ToggleButton
        type="button"
        onClick={toggleSidebar}
        aria-label={isMenuExpanded ? 'Collapse sidebar' : 'Expand sidebar'}
        data-testid="sidebar-toggle-button"
      >
        <ToggleIcon $isExpanded={isMenuExpanded}>
          <LuArrowLeftToLine size={16} />
        </ToggleIcon>
      </ToggleButton>
      {isMenuExpanded && (
        <Footer>
          A product of
          <Link href="https://gometroapp.com/" target="_blank" rel="noreferrer">
            GoMetro
          </Link>
        </Footer>
      )}
    </FloatingWrapper>
  )
}
